// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"f0a098a9","617":"ef9a923c","846":"40b9a96c"}[chunkId] + ".chunk.css";
};